import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import { Popup } from 'es6/libs/popup'
import $ from 'init/jquery'
import { isMobile } from 'init/is-mobile'
import { positionCenterOfWindow } from 'helpers/popup-positioning-helper'

/**
 * Представление всплывающего окна Соглашения на хранение персональных данных
 */
@Defaults({
  additionalOptions: ['opener', 'closer'],
  currentBackScroll: 0,
})
export class NewsAgreementPopupView extends View {
  /**
   * @inheritDoc
   */
  run () {
    let opener = this.opener || null
    let closer = this.closer
    this.popup = new Popup(this.$el, opener, closer)
    this.popup.addEventListener(
      Popup.EventType.BEFORE_OPEN,
      () => {
        this.currentBackScroll = $(document).scrollTop()
        this.trigger('popup-open')
        $('body').addClass('no-back-scroll-modify')
        if (!isMobile) {
          positionCenterOfWindow(this.$el)
        }
      }
    )
    this.popup.addEventListener(
      Popup.EventType.BEFORE_CLOSE,
      () => {
        if (closer) {
          $('body').removeClass('no-back-scroll-modify')
          this.trigger('popup-close')
          $(document).scrollTop(this.currentBackScroll)
        }
      }
    )
  }
}
